import {useState, useEffect, useRef} from 'react'
import {logMessage} from '@/services/logger/client'

export function useTrustArcCookieValue(): string | undefined {
	const [trustArcCookie, setTrustArcCookie] = useState<string | undefined>()
	const intervalRef = useRef<NodeJS.Timer | null>(null)

	const getCookieValue = (): string | undefined => {
		return document.cookie
			.split('; ')
			.find((row) => row.startsWith('notice_preferences='))
			?.split('=')[1]
	}

	useEffect(() => {
		const updateCookie = (): void => {
			const cookieValue = getCookieValue()
			if (cookieValue && cookieValue !== trustArcCookie) {
				logMessage(`Cookie value has changed to ${document.cookie}`)
				setTrustArcCookie(cookieValue)
			}
		}
		// Run initially to set the value
		updateCookie()
		// Set an interval to check for changes in the cookie every 1 second
		intervalRef.current = setInterval(updateCookie, 1000)

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current as NodeJS.Timeout)
			}
		}
	}, [trustArcCookie])

	return trustArcCookie
}
